import React from "react";

import {View, Text, ScrollView, StyleSheet, TouchableOpacity, Image, Dimensions, TextInput} from "react-native";


import {RFValue} from "react-native-responsive-fontsize";
import {FontAwesome6, Ionicons} from "@expo/vector-icons";
import Config from "../../Config";
import AntDesign from "@expo/vector-icons/AntDesign";





const Ticket =({navigation , route})=>{






    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <TouchableOpacity style={{flex : 1}} >
                    <Text style={styles.title}>
                        عنوان پیام
                    </Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={()=>{navigation.goBack()}}>
                    <Ionicons style={styles.selficon} name="arrow-back" size={24} color="white" />
                </TouchableOpacity>
            </View>
            <ScrollView style={{flex:1  , backgroundColor : '#FFF'}}>
                <View style={styles.content}>
                    <Text style={styles.date}>{route.params.singledata.jdate}  </Text>
                    <Text style={styles.itemtitle}>{route.params.singledata.subject}</Text>
                    <Text style={styles.description}>
                        {route.params.singledata.text}
                    </Text>
                </View>
            </ScrollView>


        </View>
    );
}

const styles = StyleSheet.create({




    description : {
        color: '#A6A6A6',
        fontSize: RFValue(14),
        fontFamily : 'yk',
        paddingVertical: RFValue(15),
        textAlign:'justify',
    },
    date : {
        color: '#A6A6A6',
        fontSize: RFValue(12),
        fontFamily : 'ykb',
        paddingVertical: RFValue(10),
    },

    itemtitle : {
        color: Config.maincolor,
        fontSize: RFValue(14),
        fontFamily : 'ykb',
    },


    content : {
        flex: 1,
        paddingHorizontal: RFValue(20),
        justifyContent: "center",
        paddingVertical: RFValue(20),
        backgroundColor :'#FFF',
    },

    container : {
        flex: 1,
        backgroundColor: '#FFF',
    },
    header: {
        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems : 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),

        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(17),
        fontFamily : 'ykb',
        color: '#FFF',
        paddingVertical: RFValue(14),

    },

})


export default Ticket